import type { DecisionChoose, TreeOption } from '@nsb/core';

/**
 * A decision's choice in words (design study 22): what it asks, choose one of its options or any of them, and what was
 * chosen, in the options' own words, as one line.
 */
export const chooseWords = (choose: DecisionChoose): string => (choose === 'one' ? 'Choose one' : 'Choose any');

export const chosenWords = (chosen: readonly TreeOption[]): string => chosen.map((o) => o.text).join(', ');
